import React from "react";

export default function IconSortDirectionAsc({ size = 20, ...rest }) {
  return (
    <svg width={size} height={size} {...rest} viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <path id="Vector_2" d="M8.61377 4.26087L11.0174 6.52174C11.3101 6.7971 11.3754 7.11217 11.2133 7.46696C11.0519 7.82232 10.7631 8 10.3471 8L5.58618 8C5.17018 8 4.88144 7.82232 4.71997 7.46696C4.55788 7.11217 4.62321 6.7971 4.91595 6.52174L7.31954 4.26087C7.41198 4.17391 7.51213 4.1087 7.61998 4.06522C7.72784 4.02174 7.84339 4 7.96665 4C8.08991 4 8.20547 4.02174 8.31333 4.06522C8.42118 4.1087 8.52133 4.17391 8.61377 4.26087Z" fill="currentColor" />
      </g>
    </svg>
  );
};